import styled, { css } from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Container from '../../../Core/Container';

export const NotificationBarWrapper = styled.div`
  width: 100%;
  display: table;
  position: relative;
  background-color: ${({ darkMode }) =>
    darkMode ? themeGet('colors.dark-mode') : props => props.color};
  box-shadow: inset 0 -3px 0 0 ${props => props.borderColor};
  text-align: center;
  animation-name: slideDown;
  animation-timing-function: linear;
  animation-duration: 1.5s;
  animation-delay: 1s;
  max-height: 0;
  overflow: hidden;
  animation-fill-mode: forwards;
  display: ${({ isOpen }) => (!isOpen ? 'none' : 'block')};

  ${({ fixed }) =>
    fixed &&
    css`
      position: absolute;
      z-index: 10000;
    `}

  &.hide {
    display: none;
  }

  @keyframes slideDown {
    0% {
      max-height: 0;
    }
    99% {
      max-height: 30em;
    }
    100% {
      max-height: 500em;
    }
  }
`;

export const CustomContainer = styled(Container)`
  margin: 0 auto;
  width: calc(100% - 40px);

  @media only screen and (min-width: 640px) {
    width: calc(100% - 40px);
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  position: relative;
  margin: 0 auto;
  text-align: left;
  display: inline-block;
  background-image: ${props =>
    props.backgroundImage && `url(${props.backgroundImage})`};
  background-repeat: no-repeat;
  background-position: 0 1.25rem;
  width: 100%;
  padding: 20px 40px 20px 37px;

  span {
    &.red {
      color: ${themeGet('colors.pc-red', '#E1251B')};
      font-weight: ${themeGet('fontWeights.medium')};
    }
  }

  .notification-css {
    a {
      &.notification-anchor {
        clear: both;
        width: auto;
        display: table;
        margin-top: 12px;
      }
    }
  }

  p,
  span {
    margin: 0;
    font-size: 16px;
    line-height: 22px;
    color: ${({ darkMode }) =>
      darkMode ? themeGet('colors.white') : themeGet('colors.black')};
  }

  a {
    color: ${({ darkMode }) =>
      darkMode ? themeGet('colors.white') : themeGet('colors.black')};
    font-size: 16px;
    line-height: 22px;
    font-weight: ${themeGet('fontWeights.medium')};
    cursor: pointer;

    &:hover {
      color: ${({ darkMode }) =>
        darkMode ? themeGet('colors.white') : themeGet('colors.black')};
      span {
        color: ${themeGet('colors.pc-red', '#E1251B')};
      }
    }
  }

  ul,
  ol {
    margin: 0;

    li {
      line-height: 1.57;
      font-size: 14px;
      font-weight: ${themeGet('fontWeights.normal')};
      position: relative;
      margin: 0.25rem 0;
      padding: 0 0 0 20px;
      list-style: none;
      color: ${({ darkMode }) =>
        darkMode ? themeGet('colors.white') : themeGet('colors.black')};

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        margin: 0.75rem 0;
      }

      &::before {
        content: '• ';
        color: ${themeGet('colors.pc-red', '#E1251B')};
        transform: scale(1.75);
        margin-left: -20px;
        margin-right: 10px;
        line-height: 0;
        display: block;
        position: relative;
        top: 11px;
        width: 10px;
      }

      p {
        font-size: 16px;
        line-height: 22px;
      }
    }
  }

  ol {
    li {
      &:before {
        content: none;
        margin-left: 0;
        margin-right: 0;
        top: auto;
        width: 0;
        color: ${({ darkMode }) =>
          darkMode ? themeGet('colors.white') : themeGet('colors.black')};
      }
    }
  }
`;

export const CloseBtn = styled.div`
  position: absolute;
  top: 20px;
  right: 0;
  cursor: pointer;
`;
